module.exports = __webpack_public_path__ + "img/alert-circle-icon.svg";